module.exports = __webpack_public_path__ + "img/horizontal_1_1_r_7016.38f531df.png";